import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Placeholder } from "rsuite";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faPen,
  faTrashAlt,
  faTimes,
  faUndo,
  faChartBar,
  faEye,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../../apiUrlConstant";
import { confirmAlert } from "react-confirm-alert"; // Import
import { Formik, Form, Field, ErrorMessage } from "formik";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";

import datatableOptions from "../../layout/datatableConstants";

import { Link } from "react-router-dom";


function removeLease(id, ths) {
  var del_message = "Are you sure you want to delete this item.";

  confirmAlert({
    title: "Confirm to delete",
    message: del_message,
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          axios({
            method: "post",
            url: `${apiUrl.apiUrl.url}/close-deal/valuation-delete?id=` + id,
            data: { "id": id },
          }).then(function (response) {
            ths.resetCounter();
            //ths.loadLeaseCountStatuswise();
          });
        },
      },
      {
        label: "No",
        onClick: () => {
          console.log("cancel clicked");
        },
      },
    ],
  });
}

function DeleteBtn(props) {
  return (
    <>
      <span
        className="tableActionDelete"
        onClick={() => removeLease(props.id, props.ths)}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </span>
    </>

  );
}
const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <TextField
      id="search"
      type="text"
      placeholder="Search"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
      className="searchBtn"
    />
    <ClearButton type="button" onClick={onClear}>
      <FontAwesomeIcon icon={faSearch} />
    </ClearButton>
  </>
);

const ValuationTable = ({ ths, deal_id, asset, brand, status, stateId }) => {
  //console.log(asset);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [leaseId, setLeaseId] = useState(0);
  const [popupKey, setpopupKey] = useState(0);
  React.useEffect(() => {
    fetchUsers(1);
  }, [filterText]);

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => {
          setFilterText(e.target.value);
        }}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const fetchUsers = async (page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/close-deal/get-valuation-deals?deal_id=${deal_id}&asset=${asset}&page=${page}&per_page=${perPage}&delay=1&term=${filterText}&status=${status}`
    );

    setData(response.data.data);
    setTotalRows(response.data.total);
    setLoading(false);
  };

  const handlePageChange = (page) => {
    fetchUsers(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setLoading(true);

    const response = await axios.get(
      `${apiUrl.apiUrl.url}/close-deal/get-valuation-deals?deal_id=${deal_id}&asset=${asset}&page=${page}&per_page=${newPerPage}&delay=1&status=${status}`
    );

    setData(response.data.data);
    setPerPage(newPerPage);
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers(1);
  }, []);

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [modalGraphOpen, setGraphOpen] = React.useState(false);

  function openFromParent() {
    setIsOpen(true);
  }

  function modalGraphClose() {
    setGraphOpen(false);
  }

  function handleCloseModal() {
    setIsOpen(false);
  }

  const columns = [
    {
      name: "S.No",
      selector: "srNo",
      sortable: false,
      grow: 1,
    },
    {
      name: "Month",
      selector: "month",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Year",
      selector: "year",
      sortable: false,
      grow: 3,
      wrap: true,
    },
    {
      name: "Asset Value",
      selector: "asset_value",
      sortable: false,
      grow: 3,
      wrap: true,
      style: {
        textAlign: "center",
      },
    },
    {
      name: "Action",
      grow: 3,
      sortable: false,
      cell: (record) => {
        return (
          <div>

            <span className="tableActionEdit"  >
              {/* <Link to={`/close-deals/valuation/${record.deal_id}`}> */}
              {" "}
              <FontAwesomeIcon icon={faPen} onClick={() => ths.getValuationDetails(record.id)} />
              {/* </Link> */}
            </span>
            <DeleteBtn
              id={record.id}
              ths={ths}
            ></DeleteBtn>

          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="tableContainer">
        <DataTable
          
          columns={columns}
          data={data}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
        />
      </div>

    </>
  );
};
export default ValuationTable;